/* eslint-disable no-unused-expressions */

export const convertFrom24ToAMPM = (value, minutes = '') => {
  let results = '';
  let time = '';
  if (value >= '12') {
    if (minutes) {
      time += `:${minutes} `;
    }
    time += 'PM';
    if (value === '12') {
      results += value;
      results += time;
    } else {
      results += (parseInt(value) - 12).toString();
      results += time;
    }
  } else {
    if (minutes) {
      time += `:${minutes} `;
    }
    time += 'AM';
    if (value === '00') {
      results += '12';
      results += time;
    } else {
      results += value;
      if (results.substring(0, 1) === '0') results = results.substring(1);
      results += time;
    }
  }
  return results;
};

export const getDayNumberFromDayName = (value = '') => {
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  for (let index = 0; index < days.length; index++) {
    if (days[index] === value.toLowerCase()) {
      return index;
    }
  }
};
export const getDayNameFromDayNumber = (value = 0) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  for (let index = 0; index < days.length; index++) {
    if (index === value) {
      return days[index];
    }
  }
};

export const filterItems = (
  items,
  allFilters,
  setFilteredItems,
  selectedRadioButton,
  setSelectedLocationCard,
  setSelectedMapCard,
  setLeftSideComponentToggle
) => {
  let itemResults = items;
  if (allFilters?.servicesFilter?.length !== 0) {
    itemResults = itemResults?.filter((item) => {
      let result = false;
      item?.fields?.branchServices?.map((item) => {
        if (allFilters?.servicesFilter?.includes(item?.id)) {
          result = true;
        }
      });
      return result;
    });
  }
  if (allFilters?.locationFilter?.length !== 0) {
    itemResults = itemResults?.filter((item) => {
      let result = false;
      if (allFilters?.locationFilter?.includes(item?.fields?.location?.id)) {
        result = true;
      }
      return result;
    });
  }
  if (allFilters?.bankingExperienceFilter?.length !== 0) {
    itemResults = itemResults?.filter((item) => {
      let result = false;
      item?.fields?.branchTypes?.map((item) => {
        if (allFilters?.bankingExperienceFilter?.includes(item?.id)) {
          result = true;
        }
      });
      return result;
    });
  }
  if (selectedRadioButton !== -1) {
    itemResults = itemResults?.filter((item) => {
      let result = false;
      if (selectedRadioButton === 0) {
        let timings = new Map();
        // Conditional chanining is needed because the data is deeply chained
        if (Array.isArray(item?.fields?.items)) {
          if (Array.isArray(item?.fields?.items[1]?.fields?.items)) {
            if (Array.isArray(item?.fields?.items[1]?.fields?.items[2]?.fields?.items)) {
              item?.fields?.items[1]?.fields?.items[2]?.fields?.items?.map((item) => {
                let startDay = getDayNumberFromDayName(
                  item?.fields?.startDay?.fields?.DropdownValue?.value
                );
                let endDay = getDayNumberFromDayName(
                  item?.fields?.endDay?.fields?.DropdownValue?.value
                );
                // if the day is sunday put it as 7, we will later mod it by 7
                if (endDay === 0) {
                  endDay = 7;
                }
                while (startDay <= endDay) {
                  // set the key as the number of the day
                  // set the value as the displayed object
                  timings.set(startDay % 7, {
                    opens: item?.fields?.startTime?.value,
                    closes: item?.fields?.endTime?.value,
                    isHoliday: item?.fields?.isClosed?.value,
                  });
                  startDay++;
                }
                const current = new Date();
                const openDueDate = new Date();
                const closeDueDate = new Date();
                const open = timings.get(current.getDay())?.opens;
                const close = timings.get(current.getDay())?.closes;
                if (!open || !close) {
                  return;
                }
                openDueDate.setHours(parseInt(open.substring(0, 2)), parseInt(open.substring(2)));
                closeDueDate.setHours(
                  parseInt(close.substring(0, 2)),
                  parseInt(close.substring(2))
                );
                if (current >= openDueDate && current < closeDueDate) {
                  result = true;
                }
              });
            }
          }
        }
      } else if (selectedRadioButton === 1 && item?.fields?.isAlwaysOpen?.value) {
        result = true;
      } else if (selectedRadioButton === 2 && item?.fields?.isClosedTemporarily?.value) {
        result = true;
      }
      return result;
    });
  }
  const matchFilters = (item) => {
    let numberOfMatchedFilters = 0;
    item?.fields?.branchServices?.map((item) => {
      if (allFilters?.servicesFilter?.includes(item?.id)) {
        numberOfMatchedFilters++;
      }
    });
    return numberOfMatchedFilters;
  };
  itemResults.sort(function (a, b) {
    return matchFilters(b) - matchFilters(a);
  });
  setFilteredItems(itemResults);
  setSelectedLocationCard(-1);
  setSelectedMapCard(-1);
  setLeftSideComponentToggle(false);
};

export const getDirection = (withClipboard = true, fields, longitude, latitude) => {
  let direction = '';
  if (
    !!fields?.getDirectionUrl?.value &&
    !!fields?.mapZoomLevel?.value &&
    !!longitude?.value &&
    !!latitude?.value
  ) {
    direction = fields?.getDirectionUrl?.value
      ?.replace(/{long}/g, longitude.value)
      .replace(/{lat}/g, latitude.value)
      .replace(/{zoom}/g, fields.mapZoomLevel.value);
    if (withClipboard) {
      navigator.clipboard.writeText(direction);
    }
  }
  return direction;
};
